import type { ComponentType } from 'react';
import type { CommandItemProps } from '../../../private/components/CommandsMenu';
import { embedExtension } from './embed';
import type { EmbedRendererProps } from './types';

export const createEmbedExtension = ({
  component,
  name,
  addCommandOption,
  regexp,
}: {
  regexp?: RegExp[];
  name: string;
  component: ComponentType<EmbedRendererProps<any>>;
  addCommandOption?: CommandItemProps;
  createCommand?: boolean;
}) =>
  embedExtension
    .extend({
      name,
      bubbleMenu: false,
      addEmbedSuggestionOption() {
        if (!regexp || !addCommandOption) return [];

        return [
          {
            type: name,
            name: `Embed ${addCommandOption.title}`,
            regex: regexp,
            command: ({ editor, range, link }) => {
              editor.commands.createEmbed({ type: name, href: link, range });
            },
          },
        ];
      },

      addCommandOption() {
        return addCommandOption
          ? [
              {
                ...addCommandOption,
                nextMenu: {
                  type: 'embed',
                  embedType: name,
                  ui: {
                    buttonLabel: `Embed ${addCommandOption.title}`,
                    inputPlaceholder: `Enter a ${addCommandOption.title} URL`,
                  },
                },
              },
            ]
          : [];
      },
    })
    .configure({
      component,
      name,
    });
